module.exports = __webpack_public_path__ + "static/media/auditorium_logo.a26ef1f8.png";